import { Card, CardContent, Typography, Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { RevenueByTierDataPoint } from '../../../../types/admin';

interface RevenueByTierChartProps {
  data: RevenueByTierDataPoint[];
  loading?: boolean;
}

export default function RevenueByTierChart({ data, loading }: RevenueByTierChartProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Revenue by Tier
          </Typography>
          <Skeleton variant="rectangular" height={300} />
        </CardContent>
      </Card>
    );
  }

  const xAxisData = data.map((d) => d.date);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Revenue by Tier
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Monthly revenue breakdown by subscription tier
        </Typography>
        <BarChart
          xAxis={[
            {
              data: xAxisData,
              scaleType: 'band',
              label: 'Month',
            },
          ]}
          series={[
            {
              data: data.map((d) => d.pro_revenue),
              label: 'Pro',
              stack: 'tier',
              color: '#4caf50',
            },
            {
              data: data.map((d) => d.agent_revenue),
              label: 'Agent',
              stack: 'tier',
              color: '#2196f3',
            },
            {
              data: data.map((d) => d.business_revenue),
              label: 'Business',
              stack: 'tier',
              color: '#ff9800',
            },
          ]}
          height={300}
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'top', horizontal: 'middle' },
              padding: 0,
            },
          }}
        />
      </CardContent>
    </Card>
  );
}
